// @ts-nocheck
import React, { useEffect, useState, useRef } from "react";
import { Box, Typography, Button, IconButton, Popover } from "@mui/material";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import CommonDatePicker from "../../../commonComponents/CommonDatePicker";
import CustomTextField from "../../../commonComponents/TextFieldComponent";
import { useDispatch, useSelector } from "react-redux";
import CustomSelectField from "../../../commonComponents/CommonSelect";
import { formatPhone, ssNumber } from "../../../../utils/formatUtils";
import dayjs from "dayjs";
import { getDocumentType } from "../../../../redux/slice/kybSlice";
import { AppDispatch } from "../../../../redux/store";
import Info from "../../../../assets/info.png"
import CommonPopover from "../../../commonComponents/CommonPopover";

// Define the expected types for the component props
interface FormComponentProps {
  formFields: Array<FormField>;
  title: string;
  formData: Record<string, any>;
  handleInputChange: (
    e: React.ChangeEvent<HTMLInputElement>,
    title: string,
    fieldName: string,
    index?: number,
    cursorPos?: number,
    ref?: React.RefObject<HTMLInputElement>
  ) => void;
  handleAddOwner: () => void;
  handleRemoveOwner: (ownerIndex: number) => void;
  errors: Record<string, string | undefined>;
  isUpdate?: boolean;
  componentsDisabled?: boolean;
  isPurchaseProfile?: boolean;
  radioControllling?: any
  ishideField?: boolean;
}

interface FormField {
  label: string;
  type: string;
  name: string;
}

const allowedFields = ["percentOwnership", "firstName", "lastName", "email", "phone"];
const allowedFieldsPurchaseProfile = ["percentOwnership"];

const FormComponent: React.FC<FormComponentProps> = ({
  formFields,
  title,
  formData,
  handleInputChange,
  handleAddOwner,
  handleRemoveOwner,
  errors,
  size,
  isUpdate,
  componentsDisabled,
  radioControllling,
  isPurchaseProfile,
  ishideField
}) => {
  const [types, setTypes] = useState([])
  const { states } = useSelector((state: any) => state.stateCounty);
  const { loginInvestorId, bussinessUserdata, loginUserDetails, benificialPercentage, isThisBenificialOwnerCoState, isThisBenificialOwnerState } = useSelector((state: any) => state.user);
  const { businessType } = useSelector(
    (state: any) => state.business
  );

  const dispatch = useDispatch<AppDispatch>()
  const getDocumentList = async () => {
    const payload = {
      entityType: "Member"
    }

    const response = await dispatch(getDocumentType(payload)).unwrap()
    const tempResponse = response.map((ele) => ({ value: ele.documentTypeCode, label: ele.documentName, message: ele.notes, count: ele.documentCount }))
    setTypes(tempResponse)
  }
  useEffect(() => {
    getDocumentList()
  }, [])
  const country = [{ value: "US", label: "US" }]
  const countryDocumentTypes = ["id_passport", "id_passport_card", "doc_green_card"];
  const stateDocumentTypes = ["id_drivers_license", "id_drivers_permit", "id_state"];

  const [state, setState] = useState({
    open: false,
    type: "",
    anchorEl: null,
  });

  const { open, type, anchorEl } = state;

  const [stateText, setStateText] = useState({
    openText: false,
    typeText: "",
    anchorElText: null,
  });

  const { openText, typeText, anchorElText } = stateText;
  const handleOpen = (event: any, open: boolean, type: any) => {
    setState({ open, type, anchorEl: event.currentTarget });
  };

  const handleClose = () => {
    setState((prev) => ({
      ...prev,
      open: false,
      anchorEl: null,
    }));
  };

  const handleOpenText = (event: any, openText: boolean, typeText: any) => {
    setStateText({ openText, typeText, anchorElText: event.currentTarget });
  };

  const handleCloseText = () => {
    setStateText((prev) => ({
      ...prev,
      openText: false,
      anchorElText: null,
    }));
  };

  // Popover state
  const [popover, setPopover] = useState({ open: false, anchorEl: null, text: "", ml: 10 });
  const handlePopoverOpen = (event: any, text: string, ml = 10) => {
    setPopover({ open: true, anchorEl: event.currentTarget, text, ml });
  };
  const handlePopoverClose = () => {
    setPopover({ ...popover, open: false, anchorEl: null });
  };

  // Add refs for phone and zipCode fields for each owner (for Beneficial Owner) and for main form
  const phoneRefs = useRef([]);
  const zipCodeRefs = useRef([]);
  const mainPhoneRef = useRef();
  const mainZipCodeRef = useRef();
  // Add refs for SSN fields for each owner (for Beneficial Owner) and for main form
  const ssnRefs = useRef([]);
  const mainSSNRef = useRef();

  // Field rendering helper
  const renderField = (field: FormField, value: any, error: any, onChange: any, disabled: boolean, ownerIndex?: number, disabledpercentOwnership: any) => {
    // Hide fields if not purchase profile and radioControlling is true, except for allowed fields
    if (!isPurchaseProfile && radioControllling && !allowedFields.includes(field.name)) {
      return null;
    }

    // Info popover logic
    const showInfoIcon = field.name === "documentType" || field.name === "documentId";
    let infoText = "";
    let infoMl = 10;
    if (field.name === "documentType") infoText = "Choose a government issued ID";
    if (field.name === "documentId") { infoText = "Enter ID number exactly as in the chosen document"; infoMl = ownerIndex !== undefined ? 10 : 11; }
    const typess = [{ value: "id_passport", label: "id_passport" }, { value: "id_passport_card", label: "id_passport_card" }, { value: "doc_green_card", label: "doc_green_card" }]
    if (field.type === "select") {
      let selectedValue = value || "";
      // For documentType, find the matching option from types array
      if (field.name === "documentType" && value) {
        const selectedOption = typess.find(option => option.value === value);
        selectedValue = selectedOption ? selectedOption.label : value;
      }
      return (
        <Box sx={{ display: "flex", gap: 1 }}>
          <CustomSelectField
            label={field.label}
            name={field.name}
            size={size}
            options={field.name === "documentCountry" ? country : field.name === "documentType" ? types : states}
            value={selectedValue}
            id={selectedValue}
            onChange={onChange}
            error={!!error}
            helperText={error}
            disabled={disabled}
            dataTestid={`select-test`}
          />
          {showInfoIcon && field.name === "documentType" && (
            <>
              <img
                src={Info}
                alt="info"
                onClick={e => handlePopoverOpen(e, infoText, infoMl)}
                style={{ height: "16px", width: "16px", margin: "auto" }}
              />
              <CommonPopover
                open={popover.open && popover.text === infoText}
                anchorEl={popover.anchorEl}
                onClose={handlePopoverClose}
                title={undefined}
                showCloseIcon={true}
                sx={{
                  marginTop: "28px",
                }}

              >
                <Typography variant="body2" fontWeight={400} fontSize={14} sx={{ color: "#3B3B3B", px: "5px" }}>
                  {infoText}
                </Typography>
              </CommonPopover>
            </>
          )}
        </Box>
      );
    } else if (field.type === "date") {
      return (
        <CommonDatePicker
          label={field.label || "Date of Birth"}
          name={field.name}
          touched={error}
          disableFuture={true}
          value={value || ""}
          maxDate={dayjs().subtract(18, "year").subtract(1, "day")}
          onChange={onChange}
          error={!!error}
          disabled={disabled}
          helperText={error}
          dataTestid={`datepicker-${field.name}${ownerIndex !== undefined ? `-${ownerIndex}` : ""}`}
          size={size}

        />
      );
    } else {
      // For phone, zipCode, and socialSecurityNumber, pass ref and onChange that includes cursor position
      if (field.name === "phone" || field.name === "zipCode" || field.name === "socialSecurityNumber") {
        let inputRef = undefined;
        let ownerIdx = ownerIndex !== undefined ? ownerIndex : 0;
        if (title === "Beneficial Owner") {
          if (field.name === "phone") {
            phoneRefs.current[ownerIdx] = phoneRefs.current[ownerIdx] || React.createRef();
            inputRef = phoneRefs.current[ownerIdx];
          } else if (field.name === "zipCode") {
            zipCodeRefs.current[ownerIdx] = zipCodeRefs.current[ownerIdx] || React.createRef();
            inputRef = zipCodeRefs.current[ownerIdx];
          } else if (field.name === "socialSecurityNumber") {
            ssnRefs.current[ownerIdx] = ssnRefs.current[ownerIdx] || React.createRef();
            inputRef = ssnRefs.current[ownerIdx];
          }
        } else {
          if (field.name === "phone") inputRef = mainPhoneRef;
          if (field.name === "zipCode") inputRef = mainZipCodeRef;
          if (field.name === "socialSecurityNumber") inputRef = mainSSNRef;
        }
        return (
          <CustomTextField
            ref={inputRef}
            label={field.name === "percentOwnership" ? `${field.label} ${benificialPercentage === 100 ? "" : "(50-100)"}` : field.label}
            name={field.name}
            value={value}
            onChange={e => {
              const cursorPos = e.target.selectionStart;
              handleInputChange(e, title, field.name, ownerIndex, cursorPos, inputRef);
            }}
            error={!!error}
            disabled={disabledpercentOwnership ? disabledpercentOwnership : disabled}
            helperText={error}
            dataTestid={`field-${field.name}${ownerIndex !== undefined ? `-${ownerIndex}` : ""}`}
            size={size}
            sx={{
              width: field.name === "documentId" ? '90%' : '100%',
            }}
            slotProps={{
              inputLabel: {
                sx: {
                  left: field.name === "percentOwnership" ? "-5px" : "0"
                }
              }
            }}
          />
        );
      }
      // For all other fields, keep the original renderField logic
      return (
        <div className="flex gap-1">
          <CustomTextField
            label={field.name === "percentOwnership" ? `${field.label} ${benificialPercentage === 100 ? "" : "(50-100)"}` : field.label}
            name={field.name}
            value={value}
            onChange={onChange}
            error={!!error}
            disabled={disabledpercentOwnership ? disabledpercentOwnership : disabled}
            helperText={error}
            dataTestid={`field-${field.name}${ownerIndex !== undefined ? `-${ownerIndex}` : ""}`}
            size={size}
            sx={{
              width: field.name === "documentId" ? '90%' : '100%',
            }}
            slotProps={{
              inputLabel: {
                sx: {
                  left: field.name === "percentOwnership" ? "-5px" : "0"
                }
              }
            }}
          />
          {showInfoIcon && field.name === "documentId" && (
            <>
              <img
                src={Info}
                alt="info"
                onClick={e => handlePopoverOpen(e, infoText, infoMl)}
                style={{ height: "16px", width: "16px", margin: "auto" }}
              />
              <CommonPopover
                open={popover.open && popover.text === infoText}
                anchorEl={popover.anchorEl}
                onClose={handlePopoverClose}
                title={undefined}
                showCloseIcon={true}
                sx={{
                  marginTop: "35px",

                }}
              >
                <Typography variant="body2" fontWeight={400} fontSize={14} sx={{ color: "#3B3B3B", px: "5px" }}>
                  {infoText}
                </Typography>
              </CommonPopover>
            </>
          )}
        </div>
      );
    }
  };
  // Main render
  return (
    <>
      {/* Form Fields for Beneficial Owner or other titles */}
      {title === "Beneficial Owner" ? (
        formData[title]?.map(
          (owner: Record<string, any>, ownerIndex: number) => {
            const selectedDocType = owner["documentType"];
            return (
              <Box
                key={ownerIndex}
                component="form"
                className="grid grid-cols-1 md:grid-cols-2 gap-3"
              >
                <div className="md:col-span-2 flex justify-between items-center">
                  <Typography
                    variant="h6"
                    fontSize={16}
                    fontWeight={400}
                    data-testid={`owner-title-${ownerIndex}`}
                  >
                    Enter {title} Information{" "}
                    {formData[title]?.length > 1 && `- ${ownerIndex + 1}`}
                  </Typography>
                  {ownerIndex >= 0 && formData[title]?.length > 1 && (
                    <IconButton
                      onClick={() => handleRemoveOwner(ownerIndex)}
                      data-testid={`remove-owner-${ownerIndex}`}
                    >
                      <DeleteIcon color="error" />
                    </IconButton>
                  )}
                </div>
                {formFields.map((field, fieldIndex) => {
                  // Optimized ishideField logic
                  if (ishideField && isPurchaseProfile && !allowedFieldsPurchaseProfile.includes(field.name)) {
                    return null;
                  }
                  if (ishideField && !isPurchaseProfile && !allowedFields.includes(field.name)) {
                    return null;
                  }
                  if (field.name === "documentCountry" && !countryDocumentTypes.includes(selectedDocType)) {
                    return null;
                  }
                  if (field.name === "documentState" && !stateDocumentTypes.includes(selectedDocType)) {
                    return null;
                  }
                  let fieldError = errors[ownerIndex]?.[field.name] || errors[`owner_${ownerIndex}_${field.name}`] || null;
                  let value = owner[field.name] || "";
                  if (title === "Beneficial Owner" && field.name === "socialSecurityNumber" && isPurchaseProfile && radioControllling) {
                    value = "*********";
                  } else if (field.name === "socialSecurityNumber") {
                    value = ssNumber(owner[field.name]);
                  } else if (field.name === "phone") {
                    value = formatPhone(owner[field.name]);
                  }

                  // Add document ID validation

                  const disabled = (field.name === "documentId" && !formData["Beneficial Owner"][0]?.documentType) || (title === "Beneficial Owner" && radioControllling && field.name !== "percentOwnership");
                  const disabledpercentOwnership = field.name === "percentOwnership" && benificialPercentage === 100 && (isThisBenificialOwnerCoState === 'yes' || isThisBenificialOwnerState === 'yes')

                  // Skip rendering the Box wrapper if field should be hidden
                  if (!isPurchaseProfile && radioControllling && !allowedFields.includes(field.name) && title !== "Beneficial Owner") {
                    return null;
                  }

                  return (
                    <Box key={`${ownerIndex}-${fieldIndex}`} className="w-full">
                      {renderField(
                        field,
                        value,
                        fieldError,
                        (e: any) => {
                          const args = [e, title, field.name, ownerIndex];
                          if (field.name === "percentOwnership") {
                            handleInputChange(...args, bussinessUserdata);
                          } else {
                            handleInputChange(...args);
                          }
                        },
                        disabled,
                        ownerIndex,
                        disabledpercentOwnership,
                      )}
                    </Box>
                  );
                })}
              </Box>
            );
          }
        )
      ) : (
        <Box component="form" className="grid grid-cols-1 md:grid-cols-2 gap-3">
          <div className="md:col-span-2 flex justify-between items-center">
            <Typography
              variant="h6"
              fontSize={16}
              fontWeight={400}
              data-testid={`owner-title-${title}`}
            >
              Enter {title} Information{" "}
            </Typography>
          </div>
          {formFields.map((field, index) => {
            const selectedDocType = formData[title]?.["documentType"];
            // Hide fields if not purchase profile and radioControlling is true, except for allowed fields
            if (!isPurchaseProfile && radioControllling && !allowedFields.includes(field.name) && title !== "Beneficial Owner") {
              return null;
            }
            if (field.name === "documentCountry" && !countryDocumentTypes.includes(selectedDocType)) {
              return null;
            }
            if (field.name === "documentState" && !stateDocumentTypes.includes(selectedDocType)) {
              return null;
            }
            const error = errors[field.name];
            let value = formData[title]?.[field.name] || "";
            if (field.name === "socialSecurityNumber") {
              value = ssNumber(formData[title]?.[field.name]);
            } else if (field.name === "phone") {
              value = formatPhone(formData[title]?.[field.name]);
            }
            const disabled = (field.name === "documentId" && !formData[title]?.documentType) || (field.name === "email" && isUpdate && ((radioControllling == 'no' && title == "Controlling Officer"))
              ? true
              : radioControllling
                ? radioControllling
                : false);
            return (
              <Box key={index} className="w-full">
                {renderField(
                  field,
                  value,
                  error,
                  (e: any) => handleInputChange(e, title, field.name),
                  disabled
                )}
              </Box>
            );
          })}
        </Box>
      )}
    </>
  );
};

export default FormComponent;
